import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a80aac51: FaireBrandEntity = {
  token: "b_a80aac51",
  type: "brand",
  name: "Spongellé | Summer Gifts | Father's Day",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2bdf9793f943e4d7d5c04909b31091325d9cae2bd289a7c1bb91dd93cdf4935f/1555018143.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fa00133e492bc767702a68786de2efa4858d5247d320f942e7bed7318986eb58.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2bdf9793f943e4d7d5c04909b31091325d9cae2bd289a7c1bb91dd93cdf4935f/1555018143.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fa00133e492bc767702a68786de2efa4858d5247d320f942e7bed7318986eb58.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 1521,
  isTopShop: true,
  isInsider: true,
  description:
    "Spongellé Infused Body Buffers are an amazing way to care for your skin. We created them for the most discerning customers who want the finest bath & shower experience. Infused with exotic extracts, rich moisturizers and gentle cleansers our body buffers will keep skin youthful & glowing use after use. One of a kind fragrance blends and a creamy lather make Spongellé the most luxurious bathing indulgence for your body and mind.",
  meta: {
    source: "api",
    importedAt: "2026-06-04T00:13:29.058Z",
    importedBy: "entity-db-cli",
  },
};
